export default __webpack_public_path__ + "static/media/logos.3bcedc07.png";